import React, { useState, useEffect } from 'react';

export default props=>{
    const jsx = (<div className="">
        <style jsx>{`
.fallback3 {
    position: fixed;
    z-index: 12;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);

    text-align: center;
}

.content-margin {
    margin: auto;
    padding: 50px 20px;
    max-width: 80%;

    display: inline-block;
    text-align: left;
}

.content-header {
    font-size: 28px;
}
.closeButton {
    float: right;
    cursor: pointer;
    color: white;
    transform: translate(0, 9px);
}


.fallback3 .content-margin{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    border: 0;
    padding: 0;
}

.content-body {
    border: 1px solid #888;
    background-color: #fefefe;
}

@media all and (max-width:606px) {
    .fallback3 .content-margin{
        margin: auto;
        padding: 0;
        max-width: 100%;
        position: fixed;
        top: auto;
        right: 0;
        bottom: 0;
        left: 0;
        transform: none;
    }
}

`}</style>
        <div className="fallback3" style={{ display: props.display }} onClick={props.hide} >
            <div className="content-margin">
                <div className="content-header">&nbsp;
                    <div className="closeButton" onClick={() => {
                        props.hide();
                    }} >&times;</div>
                </div>
                <div className="content-body" onClick={(e) => { e.stopPropagation() }}>
                    {props.innerContent}
                </div>
            </div>
        </div>
    </div>);    return jsx;
}
